import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

// Guards routes that require a confirmed email (e.g. merchant setup). An
// unauthenticated visitor is sent to login; an authenticated but unverified
// user is sent back to email verification rather than being allowed through.
const EmailVerifiedRoute = ({ children }) => {
  const { isAuthenticated, isEmailVerified, currentUser, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return null;
  }

  if (!isAuthenticated()) {
    const redirect = encodeURIComponent(location.pathname + location.search);
    return <Navigate to={`/login?redirect=${redirect}`} replace />;
  }

  if (!isEmailVerified()) {
    return <Navigate to="/verify-email" replace state={{ email: currentUser?.email }} />;
  }

  return children;
};

export default EmailVerifiedRoute;
